import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import type { RunState, AppDispatch } from './RunStore'

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RunState> = useSelector